import $ from 'jquery'
import config from '../store/_config'
import { spin } from './_site'
import { scrollTo, createAlert } from './window'
import { toggleSuccess, toggleError, toggleEmpty, getValue, validate } from './field'
import { axiosInstance as axios, handleAxiosErrors } from '../_utils'
import { segmentTrackParser } from '../../dashboard/utils/segment/track'
require('jquerySpin')
// import { fieldDropzone } from 'field-dropzone';
// import { fieldAddress } from 'field-address';
// import { fieldRegions } from 'field-regions';

// TODO: review "reset" function

// let timeout = {};
export const reset = ($form) => {
  var $fields = $form.find('input:visible, textarea:visible, select:visible').not('[type=submit], .selectric-input')
  // upload = fieldDropzone || false,
  // address = fieldAddress || false,
  // regions = fieldRegions || false;

  // reset form
  $form[0].reset()
  // _self.toggleSubmit($form);

  // reset fields
  $fields.each(function () {
    var $input = $(this)
    toggleSuccess(false, $input)
    toggleError(false, $input)
    toggleEmpty($input)
  })

  // // reset upload
  // if (upload) {
  //     upload.reset($form);
  // }
  //
  // // reset address
  // if (address) {
  //     address.reset($form);
  // }
  //
  // // reset regions
  // if (regions) {
  //     regions.reset($form);
  // }
}
export const removeFormValidation = () => {
  $('form').attr('novalidate', 'novalidate')
}
export const scrollToAlert = ($form, offset) => {
  scrollTo($form.find('.field__alert').first().offset().top, offset)
}
export const focusFirstfield = ($form) => {
  var $input = $form.find('.field__input:visible').first()
  if ($input.length) {
    $input.trigger('focus')
  }
}
export const createToggleSubmit = ($form) => {
  $form.each(function () {
    var $el = $(this)

    $el.on(
      'keyup.blurValidation change.blurValidation paste.blurValidation input.blurValidation',
      'input, select, textarea',
      function () {
        // var timeout = $el.data('timeout') || false;

        // prevent multiple events
        // clearTimeout(timeout);
        // timeout = setTimeout(function () {
        toggleSubmit($el)
        // }, 100);

        // $el.data('timeout', timeout);
      }
    )
    toggleSubmit($el)
  })
}
export const toggleSubmit = ($form) => {
  var flag = validateRequiredfields($form),
    $submit = $form.find('[type="submit"]')

  if (flag) {
    $submit.removeClass('button--disabled').removeAttr('disabled')
  } else {
    $submit.addClass('button--disabled').attr('disabled', 'disabled')
  }

  return flag
}
export const resetfieldValidation = ($form) => {
  $form.find('.field__input').each(function () {
    toggleSuccess(false, $(this))
    toggleError(false, $(this))
  })
}
export const toggleSubmitVisibility = ($form) => {
  var flag = checkUnpublished($form),
    $submit = $form.find('[type="submit"]')

  if (flag) {
    $submit.removeClass('hidden')
  } else {
    $submit.addClass('hidden')

    resetfieldValidation($form)
  }

  return flag
}
export const checkUnpublished = ($form) => {
  var $fields = $form.find('.field__input'),
    flag = false

  $fields.each(function () {
    var $el = $(this),
      // type = $el.is('input') ? $el.attr('type') : false,
      value = $el.is('input[type=checkbox], input[type=radio]') ? $el.prop('checked') : $el.val(),
      originalValue = $el.is('input[type=checkbox], input[type=radio]') ? $el[0].defaultChecked : $el[0].defaultValue

    if (value != originalValue) {
      flag = true
      return false
    }
  })

  return flag
}
export const traverseObject = (data) => {
  var prop, prop2
  for (prop in data) {
    if (typeof data[prop] === 'object') {
      traverseObject(data[prop])
      // verify if has array
      for (prop2 in data[prop]) {
        if (prop2.indexOf(prop) > -1) {
          // object to array
          data[prop] = $.map(data[prop], function (value) {
            return [value]
          })
          break
        }
      }
    }
  }
}
export const getDataKey = (data, block) => {
  var aux = {},
    key
  block = block.parent().closest('[data-block]')
  if (block.length && block.closest('.form').length) {
    key = block.data('block') || null
    if (key === null) {
      aux = data
    } else {
      aux[key] = data
    }
    return getDataKey(aux, block)
  } else {
    return data
  }
}
export const getData = ($form) => {
  var data = {},
    $fields = $form.find('input, select, textarea').not('.selectric-input'),
    // $blocks = $form.find('[data-block]'),
    $ignore = $($form.data('ignore'))

  // cycle fields
  $fields.each(function () {
    var $input = $(this),
      d = {},
      n = $input.attr('name'),
      $b = $input.closest('[data-block]').not($form),
      k = $b.data('block') || null

    // ignored
    if (validateIgnoreBlock($ignore, $input)) {
      return
    }
    // not visible
    if ($b.length && !$b.is(':visible')) {
      return
    }

    // get value
    if (k === null) {
      d[n] = getValue($input)
    } else {
      d[k] = {}
      d[k][n] = getValue($input)
    }

    // get key
    d = getDataKey(d, $b)

    // copy data
    $.extend(true, data, d)
  })

  // objects to array
  traverseObject(data)

  // return data
  return data
}
export const send = ($el) => {
  var $submit = $el,
    $form = $submit.closest('.form'),
    $submitAux = $submit.children('span'),
    $modal = $form.closest('.modal'),
    url = $form.data('action'),
    data = getData($form),
    submitClass = 'form__submit',
    spinner = $.extend(true, {}, spin)

  // spinner.color = '#d1b584';
  spinner.color = '#000000'

  function toggleLoader(flag) {
    if (flag) {
      // add loader
      $submit.addClass(submitClass + '--loading')
      $submitAux.spin(spinner)
    } else {
      // remove loader
      $submit.removeClass(submitClass + '--loading')
      $submitAux.spin(false)
    }
  }

  // prevent multiple clicks
  if ($submit.hasClass(submitClass + '--loading') || $submit.hasClass('button--disabled')) {
    return false
  }

  //console.log(data);

  // validation errors
  if (!validatefields($form, true)) {
    return false
  }

  // send data
  $.ajax({
    type: 'POST',
    url: url,
    data: data,
    cache: false,
    dataType: 'json',
    beforeSend: function () {
      // add loader
      toggleLoader(true)
    },
    success: function (response) {
      console.log(response)

      if (response.status) {
        // segment tracking
        // if (typeof(response.segment) !== 'undefined' && response.segment) {
        //     SegmentTracking.trigger(response.segment);
        // }
        if (response.message) {
          // create alert
          createAlert(response, 'success')
        }
        if (response.url) {
          window.location.href = response.url
          return
        }

        $modal.modal('hide')

        if ($form.is('form')) {
          reset($form)
        }
      } else {
        // create alert
        createAlert(response, 'error')
      }

      // remove loader
      toggleLoader(false)
    },
    error: function (response) {
      // create alert
      createAlert(response, 'error')
      // remove loader
      toggleLoader(false)
    },
  })
}
export const sendGraphQL = ($el, successCallback, errorCallback) => {
  var $submit = $el,
    $form = $submit.closest('.form'),
    $submitAux = $submit.children('span'),
    $modal = $form.closest('.modal'),
    queryType = $form.data('type'),
    redirectOnSuccess = $form.data('success-redirect') || false,
    graphQLConfig = config[queryType] || {},
    url = '',
    data = {
      query: '',
      variables: getData($form),
    },
    submitClass = 'form__submit',
    spinner = $.extend(true, {}, spin)

  // spinner.color = '#000000';

  if (!graphQLConfig) {
    createAlert(
      {
        message: 'Invalid GraphQL Type',
      },
      'error'
    )

    return
  }

  url = graphQLConfig.url
  data.query = graphQLConfig.query

  function toggleLoader(flag) {
    if (flag) {
      // add loader
      $submit.addClass(submitClass + '--loading')
      $submitAux.spin(spinner)
    } else {
      // remove loader
      $submit.removeClass(submitClass + '--loading')
      $submitAux.spin(false)
    }
  }

  // prevent multiple clicks
  if ($submit.hasClass(submitClass + '--loading') || $submit.hasClass('button--disabled')) {
    return false
  }

  console.log(data)

  // validation errors
  if (!validatefields($form, true)) {
    return false
  }

  toggleLoader(true)

  return axios
    .post(url, data, {
      withCredentials: true,
    })
    .then((rawResponse) => {
      const response = rawResponse.data

      if (typeof successCallback != 'undefined') {
        successCallback(response)
      }

      segmentTrackParser(queryType, data.variables)

      $modal.modal('hide')

      if ($form.is('form')) {
        reset($form)
      }

      if (redirectOnSuccess) {
        window.location.href = redirectOnSuccess
      }

      // remove loader
      toggleLoader(false)
    })
    .catch((error) => {
      handleAxiosErrors(error)

      // callback
      if (typeof errorCallback != 'undefined') {
        errorCallback(error)
      }

      // remove loader
      toggleLoader(false)
    })
}
export const swap = ($el) => {
  var $form = $el.closest('.form'),
    $targetForm = $($el.data('swap-form'))

  $form.addClass('hidden').hide()
  $targetForm.removeClass('hidden').show()
}
export const validateRequiredfields = ($form) => {
  var $fields = $form.find('input:visible, textarea:visible, select:visible').not('[type=submit], .selectric-input'),
    flag = true,
    $ignore = $($form.data('ignore'))

  $fields.each(function () {
    var $input = $(this)

    if (validateIgnoreBlock($ignore, $input)) {
      return
    }

    // no value set
    if (!validate($input)) {
      flag = false
      return false
    }
  })

  return flag
}
export const validatefields = ($form, alert) => {
  var $fields = $form.find('input:visible, textarea:visible, select:visible').not('[type=submit], .selectric-input'),
    flag = true,
    $ignore = $($form.data('ignore'))

  // cycle fields
  $fields.each(function () {
    var $input = $(this)

    if (validateIgnoreBlock($ignore, $input)) {
      return
    }

    if (!validate($input)) {
      flag = false

      // append alert
      if (alert) {
        toggleError(true, $input, true)
      }
    }
  })

  return flag
}
export const validateIgnoreBlock = ($ignore, $input) => {
  if ($input.closest($ignore).length) {
    return true
  }
  return false
}
export const binds = ($ignore, $input) => {
  removeFormValidation()

  // ---------------- form submissions
  $('body').on('submit.form', 'form', function () {
    return validatefields($(this), true)
  })

  // ---------------- edit field
  $('body').on('click.field', '[data-swap-form]', function (event) {
    event.preventDefault()
    swap($(this))
  })

  // ---------------- send form
  $('body').on('click.form', '[data-send-form]', function (event) {
    event.preventDefault()
    send($(this))
  })

  // ---------------- send form (GraphQL)
  $('body').on('click.form', '[data-send-form-graphql]', function (event) {
    console.log('clicked')
    event.preventDefault()
    sendGraphQL($(this))
  })

  // ---------------- toggle submit
  // form.createToggleSubmit($('.contact-form'));
}
